var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.existing
    ? _c("span", { staticClass: "badge-right mr-1 color" })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }